import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function PaymentPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  
  // Get pricing info from navigation state (passed from UpsellPage)
  const { 
    basePrice = 49, 
    whatsappUpsell = false, 
    expressUpsell = false, 
    totalPrice = 49 
  } = location.state || {};

  useEffect(() => {
    // Start payment immediately
    initiatePayment();
  }, []);

  const getValidAffiliateRef = () => {
    const ref = localStorage.getItem('affiliate_ref');
    const expiry = localStorage.getItem('affiliate_ref_expiry');
    if (!ref) return '';
    // Check 30-day expiry
    if (expiry && Date.now() > parseInt(expiry, 10)) {
      localStorage.removeItem('affiliate_ref');
      localStorage.removeItem('affiliate_ref_expiry');
      return '';
    }
    return ref;
  };

  const initiatePayment = async () => {
    setLoading(true);
    
    try {
      const originUrl = window.location.origin;
      const clientEmail = sessionStorage.getItem('client_email') || '';
      const affiliateRef = getValidAffiliateRef();
      const discountCode = sessionStorage.getItem('discount_code') || '';
      
      const response = await axios.post(
        `${API_URL}/api/payments/checkout/session`,
        {
          whatsapp_upsell: whatsappUpsell,
          express_upsell: expressUpsell,
          client_email: clientEmail,
          origin_url: originUrl,
          affiliate_ref: affiliateRef,
          discount_code: discountCode
        }
      );
      
      // Redirect to Stripe Checkout
      if (response.data.url) {
        window.location.href = response.data.url;
      } else {
        throw new Error('No checkout URL returned');
      }
    } catch (error) {
      console.error('Payment error:', error);
      toast.error('Erreur lors de l\'initialisation du paiement');
      setLoading(false);
      
      // Redirect back to upsell page after 2 seconds
      setTimeout(() => {
        navigate('/upsell');
      }, 2000);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center max-w-md">
        {loading ? (
          <>
            <div className="text-6xl mb-6">💳</div>
            <h2 className="text-2xl font-bold mb-4 text-foreground">
              Redirection vers le paiement sécurisé...
            </h2>
            <p className="text-muted-foreground mb-4">
              Montant total : <strong className="text-primary">CHF {totalPrice}</strong>
            </p>
            <div className="flex justify-center items-center gap-2 text-sm text-muted-foreground">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
              <span>Veuillez patienter...</span>
            </div>
            
            {whatsappUpsell && (
              <p className="text-xs text-success mt-4">✓ WhatsApp Conseiller inclus</p>
            )}
            {expressUpsell && (
              <p className="text-xs text-success">✓ Livraison Express 24h incluse</p>
            )}
          </>
        ) : (
          <>
            <div className="text-6xl mb-6">⚠️</div>
            <h2 className="text-2xl font-bold mb-4 text-foreground">
              Erreur de paiement
            </h2>
            <p className="text-muted-foreground">
              Redirection en cours...
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default PaymentPage;
